/**
 * The registrable domain the `app.`/`www.`/apex hosts share, derived from our
 * own hostname: a subdomain host (`app.`/`www.`) shares it one label up
 * (`www.movegoalpost.com` → `movegoalpost.com`), and the apex is already that
 * domain. A single-label host like `localhost` has no shareable parent, so this
 * returns undefined and the cookie is written host-only (still shared across the
 * dev ports, since cookies ignore the port). Assumes Goalpost's host topology —
 * hosts sit one label below the shared domain — per docs/webapp.md.
 *
 * Shared by every cookie that must cross the `www.`→`app.` origin hop: the theme
 * preference (`useTheme.tsx`), the `li_fat_id` ad bridge (`li-fat-id.ts`), and
 * the experiment bridge (`experiments.ts`).
 */
export function sharedCookieDomain(): string | undefined {
  const host = window.location.hostname;
  const labels = host.split('.');
  if (labels.length < 2) return undefined;
  return labels.length > 2 ? labels.slice(1).join('.') : host;
}
